import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

import {
  setCredentials,
  logOut,
} from '../../features/auth/authSlice';

/*
 * Local React:
 *
 *   http://localhost:3000
 *          ↓
 *   http://localhost:3500
 *
 * Deployed dev:
 *
 *   https://dev.usfuelpro.com
 *          ↓
 *   https://dev-api.usfuelpro.com
 *
 * Production:
 *
 *   https://usfuelpro.com
 *          ↓
 *   https://api.usfuelpro.com
 */
const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3500'
      : ''
  );

if (!apiBaseUrl) {
  console.error(
    'REACT_APP_API_BASE_URL is not set. ' +
    'API requests will use same-origin and likely fail.'
  );
}

console.log(
  'USFuel API base URL:',
  apiBaseUrl || '<same-origin>'
);

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,

  credentials: 'include',

  prepareHeaders: (
    headers,
    { getState }
  ) => {
    const token =
      getState().auth.token;

    if (token) {
      headers.set(
        'authorization',
        `Bearer ${token}`
      );
    }

    return headers;
  },
});

const baseQueryWithReauth = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(
    args,
    api,
    extraOptions
  );

  const isForbidden =
    result?.error?.status === 403 ||
    result?.error?.originalStatus === 403;

  if (isForbidden) {
    console.log(
      'Attempting refresh token...'
    );

    const refreshResult =
      await baseQuery(
        '/auth/refresh',
        api,
        extraOptions
      );

    if (refreshResult?.data) {
      const user =
        api.getState().auth.user;

      api.dispatch(
        setCredentials({
          ...refreshResult.data,
          user,
        })
      );

      /*
       * Retry original request after refresh.
       */
      result = await baseQuery(
        args,
        api,
        extraOptions
      );
    } else {
      api.dispatch(
        logOut()
      );

      if (
        refreshResult?.error?.status === 403
      ) {
        refreshResult.error.data = {
          ...(refreshResult.error.data || {}),
          message:
            'Your login has expired.',
        };
      }

      return refreshResult;
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,

  endpoints: () => ({}),
});